import { VOEmoji } from "../model/DataStructure.js";
import { EmojiPlayer } from "./EmojiPlayer.js";

export interface EmojiOptions {
    container: HTMLElement;
    data: VOEmoji;
    onClick: (e: EmojiSelectorItem) => void;
    onDragStart: (e: EmojiSelectorItem, actor: e5.Click) => void;
}

export class EmojiSelectorItem {

    public onClick = e5.Signal.create<[EmojiSelectorItem]>();
    public onDragStart = e5.Signal.create<[EmojiSelectorItem, e5.Click]>();

    public data: VOEmoji;
    public element: HTMLDivElement;

    private _actor: e5.Click;
    private _options: EmojiOptions;
    private _player: EmojiPlayer;
    private _playing: boolean = false;

    constructor(options: EmojiOptions) {
        options = e5.object.merge({

        }, options);
        this._options = options;

        this.data = options.data;

        this.element = document.createElement("div");
        this.element.className = "emoji-selector-item";
        this.element.setAttribute("data-layout", "compact");
        this.element.setAttribute("data-state", "paused");
        this.element.innerHTML = `
        <div class="emoji-selector-item__body">
            <div class="emoji-selector-item__shadow"></div>
            <div class="emoji-selector-item__player"></div>
        </div>
        <div class="emoji-selector-item__footer">
            <button class="emoji-selector-item__button">
                <i class="emoji-selector-item__button-icon emoji-selector-item__button-icon--active fal fa-stop"></i>
                <i class="emoji-selector-item__button-icon emoji-selector-item__button-icon--inactive fal fa-play"></i>
            </button>
        </div>
        `;

        this._player = new EmojiPlayer({
            container: this.element.querySelector(".emoji-selector-item__player"),
            lottieData: options.data.lottieData,
            duration: options.data.melody.duration
        });

        if (typeof options.onDragStart === "function") {
            this.onDragStart.add(options.onDragStart);
        }

        this._actor = new e5.Click(
            this.element.querySelector(".emoji-selector-item__player"),
            {
                preventDefault: true
            }
        );

        this._actor.onStart.add(() => {
            this.onDragStart.dispatch(this, this._actor);
        });

        this.onClick.add(options.onClick);

        this.element.querySelector(".emoji-selector-item__footer")
            .addEventListener("click", () => {
                // if (this._element.getAttribute("data-layout") == "compact") {
                //     this._element.setAttribute("data-layout", "card");
                // } else {
                //     this._element.setAttribute("data-layout", "compact");
                // }

                // this.playing = !this.playing;

                this.onClick.dispatch(this);
            });

        options.container.appendChild(this.element);
    }

    public get grayscale(): boolean {
        return this._player.grayscale;
    }

    public set grayscale(value: boolean) {
        this._player.grayscale = value;
    }

    public get playing(): boolean {
        return this._playing;
    }

    public set playing(value: boolean) {
        if (this._playing == value) {
            return;
        }
        this._playing = value;

        this._player.playing = value;
        this.element.setAttribute("data-state", value ? "playing" : "paused");
        this.element.querySelector(".emoji-selector-item__button").classList.toggle("emoji-selector-item__button--active", value);
    }

    public get dragging(): boolean {
        return this.element.classList.contains("emoji-selector-item--dragging");
    }

    public set dragging(value: boolean) {
        this.element.classList.toggle("emoji-selector-item--dragging", value);
    }

    public get visible(): boolean {
        return !this.element.classList.contains("e5-hidden");
    }

    public set visible(value: boolean) {
        this.element.classList.toggle("e5-hidden", !value);
    }

    public get disabled(): boolean {
        return this.element.classList.contains("emoji-selector-item--disabled");
    }

    public set disabled(value: boolean) {
        this.element.classList.toggle("emoji-selector-item--disabled", value);
        if (value) {
            this.element.setAttribute("inert", "on");
        }
        else {
            this.element.removeAttribute("inert");
        }
    }
}